import { usePopupPosition as lib } from 'use-rects';
import type { AlignType } from 'use-rects';

export const usePopupPosition = (align?: AlignType) => {
  return lib({ delay: 20, align });
};
